import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Brain, TrendingUp, ChevronRight } from 'lucide-react';
// import { Button } from "@/components/ui/button";
// import { Input } from "@/components/ui/input";
// import GridBackground from '@/components/landing/GridBackground';
import GridBackground from "../components/landing/GridBackground";
import FloatingElements from '../components/landing/FloatingElements';

export default function Home() {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleWaitlist = (e) => {
    e.preventDefault();
    if (email) {
      setIsSubmitted(true);
      setEmail('');
    }
  };

  return (
    <div className="min-h-screen bg-white relative overflow-hidden">
      <GridBackground />
      <FloatingElements />
      
      {/* Header */}
      <header className="relative z-50">
        <nav className="max-w-7xl mx-auto px-6 py-6 flex items-center justify-between">
          <motion.div 
            className="flex items-center gap-2"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="w-10 h-10 bg-gradient-to-br from-violet-600 to-purple-700 rounded-xl flex items-center justify-center shadow-lg shadow-violet-500/30">
              <span className="text-white font-black text-lg">P</span>
            </div>
            <span className="font-black text-xl tracking-tight text-gray-900">POLYNORI</span>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="hidden sm:flex items-center gap-6"
          >
            <span className="text-sm text-gray-500 font-medium">The Platform</span>
            <div className="h-4 w-px bg-gray-200" />
            <a href="https://x.com/Noracleio" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-gray-600 transition-colors">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
            </a>
            <a href="https://discord.gg/mJ7z6rjmFc" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-gray-600 transition-colors">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/></svg>
            </a>
          </motion.div>
        </nav>
      </header>

      {/* Hero Section */}
      <main className="relative z-10 max-w-7xl mx-auto px-6 pt-16 sm:pt-24 lg:pt-32 pb-32">
        <div className="text-center max-w-4xl mx-auto">
          {/* Coming Soon Badge */}
          <motion.div
              initial={{opacity: 0, y: 20}}
              animate={{opacity: 1, y: 0}}
              transition={{duration: 0.6, delay: 0.2}}
              className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-violet-100 to-purple-100 border border-violet-200/50 mb-8"
          >
            <span className="relative flex h-2 w-2">
              <span
                  className="animate-ping absolute inline-flex h-full w-full rounded-full bg-violet-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-violet-500"></span>
            </span>
            <span className="text-sm font-semibold text-violet-700">Coming Soon</span>
          </motion.div>

          {/* Main Headline */}
          <motion.h1
              className="text-5xl sm:text-6xl lg:text-7xl font-black text-gray-900 tracking-tight leading-[1.1] mb-6"
              initial={{opacity: 0, y: 30}}
              animate={{opacity: 1, y: 0}}
              transition={{duration: 0.7, delay: 0.3}}
          >
            Trade your{' '}
            <span
                className="bg-gradient-to-r from-violet-600 via-purple-600 to-fuchsia-600 bg-clip-text text-transparent">
              Beliefs
            </span>
            {' '}and{' '}
            <span className="bg-gradient-to-r from-fuchsia-600 via-pink-600 to-rose-500 bg-clip-text text-transparent">
              Strategies
            </span>
          </motion.h1>

          {/* Subtitle */}
          <motion.p
              className="text-lg sm:text-xl text-gray-500 max-w-2xl mx-auto mb-10 leading-relaxed"
              initial={{opacity: 0, y: 20}}
              animate={{opacity: 1, y: 0}}
              transition={{duration: 0.6, delay: 0.5}}
          >
            Reshaping prediction games and markets with adaptive{' '}
            <span className="text-gray-700 font-semibold">AI-driven strategies</span>
          </motion.p>

          <motion.p
              className="text-sm sm:text-base text-gray-600 max-w-2xl mx-auto mb-10"
              initial={{opacity: 0, y: 14}}
              animate={{opacity: 1, y: 0}}
              transition={{duration: 0.6, delay: 0.55}}
          >
            <a
                href="https://medium.com/@media.noracle/polynori-building-the-ai-strategy-layer-for-the-worlds-prediction-economy-dd888c0ee7cf?postPublishedType=initial"
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-1.5 font-medium text-gray-800 hover:text-black transition-colors underline underline-offset-4"
            >
              Discover how PolyNori is building the AI strategy layer for the world’s prediction economy
              <ChevronRight className="w-4 h-4"/>
            </a>
          </motion.p>

          {/* Feature Pills */}
          <motion.div
              className="flex flex-wrap justify-center gap-3 mb-12"
              initial={{opacity: 0, y: 20}}
              animate={{opacity: 1, y: 0}}
              transition={{duration: 0.6, delay: 0.6}}
          >
            <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-gray-50 border border-gray-100">
              <Brain className="w-4 h-4 text-violet-500"/>
              <span className="text-sm font-medium text-gray-700">Powered by NORACLE</span>
            </div>
          </motion.div>

          {/* Category Cards */}
          <motion.div
              className="flex flex-wrap items-center justify-center gap-4 sm:gap-6"
              initial={{opacity: 0, y: 20}}
              animate={{opacity: 1, y: 0}}
              transition={{duration: 0.6, delay: 0.7}}
          >
            <motion.div
                whileHover={{scale: 1.05, rotate: -2}}
                transition={{type: "spring", stiffness: 300}}
                className="relative group"
            >
              <div
                  className="absolute inset-0 bg-gradient-to-r from-violet-500 to-purple-600 rounded-2xl blur-xl opacity-50 group-hover:opacity-70 transition-opacity"/>
              <div
                  className="relative bg-gradient-to-br from-violet-500 to-purple-600 rounded-2xl px-8 py-6 shadow-2xl shadow-violet-500/40">
                <span className="text-white font-black text-2xl tracking-wide">Lotteries</span>
                <div
                    className="absolute -top-2 -right-2 w-6 h-6 bg-yellow-400 rounded-full flex items-center justify-center text-sm">
                  🎰
                </div>
              </div>
            </motion.div>

            <motion.div
                whileHover={{scale: 1.05, rotate: 2}}
                transition={{type: "spring", stiffness: 300}}
                className="relative group"
            >
              <div
                  className="absolute inset-0 bg-gradient-to-r from-emerald-500 to-teal-600 rounded-2xl blur-xl opacity-50 group-hover:opacity-70 transition-opacity"/>
              <div
                  className="relative bg-gradient-to-br from-emerald-500 to-teal-600 rounded-2xl px-8 py-6 shadow-2xl shadow-emerald-500/40">
                <span className="text-white font-black text-2xl tracking-wide">Games</span>
                <div
                    className="absolute -top-2 -right-2 w-6 h-6 bg-pink-400 rounded-full flex items-center justify-center text-sm">
                  🎮
                </div>
              </div>
            </motion.div>

            <motion.div
                whileHover={{scale: 1.05, rotate: -2}}
                transition={{type: "spring", stiffness: 300}}
                className="relative group"
            >
              <div
                  className="absolute inset-0 bg-gradient-to-r from-orange-500 to-amber-600 rounded-2xl blur-xl opacity-50 group-hover:opacity-70 transition-opacity"/>
              <div
                  className="relative bg-gradient-to-br from-orange-500 to-amber-600 rounded-2xl px-8 py-6 shadow-2xl shadow-orange-500/40">
                <span className="text-white font-black text-2xl tracking-wide">Sports</span>
                <div
                    className="absolute -top-2 -right-2 w-6 h-6 bg-lime-400 rounded-full flex items-center justify-center text-sm">
                  ⚽
                </div>
              </div>
            </motion.div>

            <motion.div
                whileHover={{scale: 1.05, rotate: 2}}
                transition={{type: "spring", stiffness: 300}}
                className="relative group"
            >
              <div
                  className="absolute inset-0 bg-gradient-to-r from-rose-500 to-pink-600 rounded-2xl blur-xl opacity-50 group-hover:opacity-70 transition-opacity"/>
              <div
                  className="relative bg-gradient-to-br from-rose-500 to-pink-600 rounded-2xl px-8 py-6 shadow-2xl shadow-rose-500/40">
                <span className="text-white font-black text-2xl tracking-wide">Trading</span>
                <div
                    className="absolute -top-2 -right-2 w-6 h-6 bg-cyan-400 rounded-full flex items-center justify-center text-sm">
                  📈
                </div>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </main>

      {/* Footer */}
      <footer className="relative z-10 border-t border-gray-100 bg-white/80 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-gray-400">© 2025 POLYNORI. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-sm text-gray-400 hover:text-gray-600 transition-colors">Terms</a>
            <a href="#" className="text-sm text-gray-400 hover:text-gray-600 transition-colors">Privacy</a>
          </div>
        </div>
      </footer>
    </div>
  );
}